module.exports = __webpack_public_path__ + "static/media/intro.e56b2be9.mp3";